export default __webpack_public_path__ + "static/icon-render-cells-a62010936f2cd75b41630ed6842aa68e.svg";